// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { UserPermissionIds, UserTypes } from '@interfaces/user.interfaces';
import { BasePermissionGuard } from './base-permission.guard';
import { Injectable } from '@angular/core';
@Injectable({
    providedIn: 'root',
})
export class DealsGuard extends BasePermissionGuard {
    userTypes = [UserTypes.Dealer, UserTypes.Internal];
    permissions = [UserPermissionIds.Deals];
}
